import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { logout } from '../store/slices/authSlice';
import Cookies from 'js-cookie';

export const useApiError = (error: any) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (error) {
      // Проверяем статус ошибки
      const status = error?.status || error?.error?.status;
      
      console.log('API Error Details:', {
        status,
        error: error?.error,
        data: error?.data,
        message: error?.error?.data?.message || error?.data?.message,
        originalError: error
      });
      
      // Если 401 (Unauthorized) или 500 (Internal Server Error), очищаем токен
      if (status === 401 || status === 500) {
        console.log('Clearing token due to error:', status);
        
        // Очищаем токен из куки
        Cookies.remove('token');
        
        // Очищаем токен из localStorage
        localStorage.removeItem('token');
        
        // Обновляем Redux store
        dispatch(logout());
      }
    }
  }, [error, dispatch]);
}; 